export interface PurchaseOrderLineRequirement {
  id: string;
  selected: boolean;
  purchaseOrderLineId: string;
  purchaseOrderAndLineNo: string;
  productId: string;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  quantity: number;
  allocated: number;
  issued: number;
  canDelete: boolean;
  suppliedByUs: boolean;
  manufacturerProduct: boolean;
}
